export type CartItem = {
  productId: string
  variantId: string
  name: string
  variantName: string
  price: number
  quantity: number
  image?: string
  slug: string
  categorySlug: string
}

export type Cart = {
  items: CartItem[]
}

const STORAGE_KEY = 'divemate_cart'

export function loadCart(): Cart {
  if (typeof window === 'undefined') return { items: [] }
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return { items: [] }
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed?.items)) {
      localStorage.removeItem(STORAGE_KEY)
      return { items: [] }
    }
    // Filtruj nieprawidłowe pozycje — sama obecność kluczy nie wystarczy,
    // uszkodzony wpis (quantity: "abc", price: null, wartości ujemne) dawał NaN w UI.
    const validItems = parsed.items.filter((i: unknown) => {
      if (!i || typeof i !== 'object') return false
      const item = i as Record<string, unknown>
      return (
        typeof item.variantId === 'string' && item.variantId.length > 0 &&
        typeof item.price === 'number' && Number.isFinite(item.price) && item.price > 0 &&
        typeof item.quantity === 'number' && Number.isInteger(item.quantity) &&
        item.quantity > 0 && item.quantity <= 99
      )
    })
    return { items: validItems }
  } catch {
    return { items: [] }
  }
}

export function saveCart(cart: Cart): void {
  if (typeof window === 'undefined') return
  localStorage.setItem(STORAGE_KEY, JSON.stringify(cart))
}

export function cartTotal(items: CartItem[]): number {
  return items.reduce((sum, item) => sum + item.price * item.quantity, 0)
}

export function cartCount(items: CartItem[]): number {
  return items.reduce((sum, item) => sum + item.quantity, 0)
}
